module.exports = __webpack_public_path__ + "static/img/pappa.aca549e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pappa.jpg
// module id = FP3U
// module chunks = 1